import React from 'react';

const formatCurrency = (value) => {
    if (value == null) return "N/A";
    if (value >= 1000000) {
        return `Rs. ${(value / 1000000).toFixed(2)} Million`;
    }
    return `Rs. ${value.toLocaleString()}`;
};

const formatUnits = (value) => {
    if (value == null || isNaN(value)) return "N/A";
    return Number(value).toLocaleString(undefined, { maximumFractionDigits: 2 });
};

const BillSummaryCards = ({
    recentBill,
    recentUnits,
    forecastBill,
    forecastUnits,
    dailyAverageUsage,
    analyzedDays,
    lastReadingDate,
    recentMonthLabel,
    forecastMonthLabel
}) => {

    const cards = [
        {
            title: "Recent Bill",
            value: formatCurrency(recentBill),
            subtitle: `For ${recentMonthLabel || 'N/A'}`,
            bgColor: "#002f46", // Dark Navy
            icon: (
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: 0.6 }}>
                    <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
                </svg>
            )
        },
        {
            title: "Recent Bill Units",
            value: formatUnits(recentUnits),
            subtitle: `For ${recentMonthLabel || 'N/A'}`,
            bgColor: "#009f8d", // Enfo Teal
            icon: (
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: 0.6 }}>
                    <path d="M3 3v18h18"></path>
                    <path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14.3"></path>
                </svg>
            )
        },
        {
            title: "Bill Forecast",
            value: formatCurrency(forecastBill),
            subtitle: `For ${forecastMonthLabel || 'N/A'}`,
            bgColor: "#ff9c07", // Enfo Orange
            icon: (
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: 0.6 }}>
                    <rect x="2" y="6" width="20" height="12" rx="2"></rect>
                    <circle cx="12" cy="12" r="2"></circle>
                    <path d="M6 12h.01M18 12h.01"></path>
                </svg>
            )
        },
        {
            title: "Bill Forecast Units",
            value: `${formatUnits(forecastUnits)} Units`,
            subtitle: `For ${forecastMonthLabel || 'N/A'}`,
            bgColor: "#005051", // Deep Teal
            icon: (
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: 0.6 }}>
                    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
                </svg>
            )
        },
        {
            title: "Daily Avg Usage",
            value: `${formatUnits(dailyAverageUsage)} Units`,
            subtitle: "Derived from the last reading date",
            bgColor: "#004466", // Slightly lighter Dark Navy
            icon: (
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: 0.6 }}>
                    <line x1="18" y1="20" x2="18" y2="10"></line>
                    <line x1="12" y1="20" x2="12" y2="4"></line>
                    <line x1="6" y1="20" x2="6" y2="14"></line>
                </svg>
            )
        }
    ];

    return (
        <div style={styles.container}>
            {cards.map((card, idx) => (
                <div key={idx} style={{ ...styles.card, backgroundColor: card.bgColor }}>
                    <div style={styles.iconWrapper}>
                        {card.icon}
                    </div>
                    <div style={styles.contentWrapper}>
                        <div style={styles.title}>{card.title}</div>
                        <div style={styles.value}>{card.value}</div>
                        <div style={styles.subtitle}>{card.subtitle}</div>
                    </div>
                </div>
            ))}
        </div>
    );
};

const styles = {
    container: {
        display: 'flex',
        gap: '20px',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        marginBottom: '24px'
    },
    card: {
        flex: '1 1 200px',
        minWidth: '220px',
        borderRadius: '8px',
        padding: '20px',
        display: 'flex',
        alignItems: 'center',
        color: '#fff',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
        position: 'relative',
        overflow: 'hidden'
    },
    iconWrapper: {
        position: 'absolute',
        left: '20px',
        top: '50%',
        transform: 'translateY(-50%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    contentWrapper: {
        marginLeft: '60px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        zIndex: 1
    },
    title: {
        fontSize: '14px',
        fontWeight: '500',
        marginBottom: '8px',
        opacity: 0.9
    },
    value: {
        fontSize: '24px',
        fontWeight: 'bold',
        marginBottom: '8px'
    },
    subtitle: {
        fontSize: '12px',
        opacity: 0.8
    }
};

export default BillSummaryCards;
